import * as React from 'react';
import { connect } from 'react-redux';
import { IStore } from 'redux/IStore';

interface IState {
	height: number;
}

class AdminServerLogComponent extends React.Component<ReturnType<typeof stateToProps>, IState> {
	constructor(props) {
		super(props);

		this.resize = this.resize.bind(this);
		this.state = {
			height: 800,
		};
	}

	public componentDidMount(): void {
		if (typeof window !== 'undefined') {
			window.addEventListener('resize', this.resize);
			this.resize();
		}
	}
	public componentWillUnmount(): void {
		if (typeof window !== 'undefined') {
			window.removeEventListener('resize', this.resize);
		}
	}

	private resize() {
		if (typeof window === 'undefined') {
			return;
		}
		const height = window.innerHeight - 100;
		if (height !== this.state.height) {
			this.setState({ height });
		}
	}

	public render() {
		const { accessToken, baseApi } = this.props;
		if (!accessToken) {
			return <h1>Unauthorized</h1>;
		}
		return (
			<div>
				<iframe
					src={baseApi + 'elmah?authorization=' + accessToken}
					frameBorder="0"
					width="100%"
					height={this.state.height}
					scrolling="yes"
					seamless={true}
				/>
			</div>
		);
	}
}

const stateToProps = (state: IStore) => ({
	baseApi: state.fetchDefault.baseAPI,
	accessToken: state.fetchDefault.accessToken,
});

const AdminServerLog = connect(stateToProps)(AdminServerLogComponent);

export { AdminServerLog };
